jQuery(document).ready(function($) {
  'use strict';

  // initialize the megamenu
  // ADOBE ACCESSIBLE MEGAMENU
  $('.nav--primary').accessibleMegaMenu({
    /* prefix for generated unique id attributes, which are required
    to indicate aria-owns, aria-controls and aria-labelledby */
    uuidPrefix: 'accessible-megamenu',

    /* css class used to define the megamenu styling */
    menuClass: 'menu--main',

    /* css class for a top-level navigation item in the megamenu */
    topNavItemClass: 'menu__item',

    /* css class for a megamenu panel */
    panelClass: 'menu__subnav',

    /* css class for a group of items within a megamenu panel */
    panelGroupClass: 'menu__subnav',

    /* css class for the hover state */
    hoverClass: 'hover',

    /* css class for the focus state */
    focusClass: 'focus',

    /* css class for the open state */
    openClass: 'open',
  });

  $('.menu--main').removeAttr('role');
  $('.menu__subnav').removeAttr('role');

  // Submenu Close Button
  $('.menu__subnav--close').click(function() {
    $('.menu__subnav')
      .hide()
      .removeClass('open');

    setTimeout(function() {
      $('.menu__subnav').removeAttr('style');
    }, 200);
  });
});
